import { createSlice } from "@reduxjs/toolkit";
import { loginUser, registerUser, updateProfile, activateAccount, requestPasswordReset, confirmPasswordReset } from "./authThunks.js";


const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  token: localStorage.getItem("token") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  loading: false,
  error: null,

  activationLoading: false,
  activationError: null,
  activationSuccessMessage: null,

  passwordResetLoading: false,
  passwordResetError: null,
  passwordResetSuccessMessage: null,

};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.loading = false;
      state.error = null;

      state.activationLoading = false;
      state.activationError = null;
      state.activationSuccessMessage = null;

      state.passwordResetLoading = false;
      state.passwordResetError = null;
      state.passwordResetSuccessMessage = null;

      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    updateProfileSettings(state, action) {
      const updatedFields = action.payload;
      if (state.user) {
        state.user = { ...state.user, ...updatedFields };
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
    clearActivationState(state) {
      state.activationLoading = false;
      state.activationError = null;
      state.activationSuccessMessage = null;
    },
    clearPasswordResetState(state) {
      state.passwordResetLoading = false;
      state.passwordResetError = null;
      state.passwordResetSuccessMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.user = action.payload.user;

        localStorage.setItem("token", action.payload.token);
        localStorage.setItem("refreshToken", action.payload.refreshToken);
        localStorage.setItem("user", JSON.stringify(action.payload.user));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al iniciar sesión";
      })

      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload; // OJO: esto no loguea, solo guarda lo que devuelva el backend
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al registrarse";
      })

      // Activate account
      .addCase(activateAccount.pending, (state) => {
        state.activationLoading = true;
        state.activationError = null;
        state.activationSuccessMessage = null;
      })
      .addCase(activateAccount.fulfilled, (state, action) => {
        state.activationLoading = false;
        state.activationSuccessMessage = action.payload?.detail || "Cuenta activada correctamente.";
      })
      .addCase(activateAccount.rejected, (state, action) => {
        state.activationLoading = false;
        state.activationError = action.payload || "No se pudo activar la cuenta";
      })

      // Update Profile
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        localStorage.setItem("user", JSON.stringify(action.payload));
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al actualizar el perfil";
      })

      // Password reset (request + confirm)
      .addCase(requestPasswordReset.pending, (state) => {
        state.passwordResetLoading = true;
        state.passwordResetError = null;
        state.passwordResetSuccessMessage = null;
      })
      .addCase(requestPasswordReset.fulfilled, (state, action) => {
        state.passwordResetLoading = false;
        state.passwordResetSuccessMessage = action.payload?.detail || "Revisa tu email.";
      })
      .addCase(requestPasswordReset.rejected, (state, action) => {
        state.passwordResetLoading = false;
        state.passwordResetError = action.payload || "Error en recuperación";
      })

      .addCase(confirmPasswordReset.pending, (state) => {
        state.passwordResetLoading = true;
        state.passwordResetError = null;
        state.passwordResetSuccessMessage = null;
      })
      .addCase(confirmPasswordReset.fulfilled, (state, action) => {
        state.passwordResetLoading = false;
        state.passwordResetSuccessMessage = action.payload?.detail || "Contraseña actualizada.";
      })
      .addCase(confirmPasswordReset.rejected, (state, action) => {
        state.passwordResetLoading = false;
        state.passwordResetError = action.payload || "Error al restablecer";
      })
  },
});

export const { logout, updateProfileSettings, clearActivationState, clearPasswordResetState } = authSlice.actions;
export default authSlice.reducer;